import React from 'react'
import CustomTable from "../../../Components/CustomTable";
import { FormatDate, FormatRealNumber } from '../../../Components/Helper/FormatValues';
import { ShowSituation, ShowPriority } from '../../../Components/ShowInfos';
import DialogViewTask from '../../../Components/Screens/ViewTask';
import { ShowProjectStatus } from '../../../Components/ShowInfos';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Box,
} from '@material-ui/core';
import { Info as InfoIcon, Close as CloseIcon } from '@material-ui/icons';
import { useParams } from 'react-router-dom';

const JustificationDialog = ({ open, onClose, justifications }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Justificativas
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Justificativa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {justifications.map((justification, index) => (
              <TableRow key={index}>
                <TableCell>{FormatDate(justification.date)}</TableCell>
                <TableCell>
                  <ShowProjectStatus type={justification.status} value={0} />
                </TableCell>
                <TableCell>{justification.text}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default function ReadTable({data, updateData, error, load, className}) {
  const [rowId, setRowId] = React.useState(null)
  const [open, setOpen] = React.useState(true);
  const [justificationOpen, setJustificationOpen] = React.useState(false);
  const [selectedJustifications, setSelectedJustifications] = React.useState([]);

  const { id } = useParams();

  const handleOpen = (id)=>{
    setRowId(id)
    setOpen(true)
  }

  const handleClose = ()=>{
    setOpen(false)
    setRowId(null)
  }

  const handleJustificationClick = React.useCallback((justifications) => {
    setSelectedJustifications(justifications);
    setJustificationOpen(true);
  }, []);

  const options = {onRowClick: (rowData, rowState) => handleOpen(rowData[0])};

  const columns = React.useMemo(() => [
    { name: "taskId", options: { display: "false" } },
    { name: "name", label: "Etapa", options: { filter: true, sort: true } },
    { name: "taskType", label: "Tipo", options: { filter: true, sort: true } },
    { name: "responsibleSecretary", label: "Secretaria", options: { filter: true, sort: true } },
    { name: "responsible", label: "Responsável", options: { filter: true, sort: true } },
    { name: "statusId", label: "Status", options: { filter: true, sort: true,
      customBodyRender: (value) => <ShowProjectStatus type={parseInt(value ?? "0")} value={0}/>}
    },
    { name: "situation", label: "Situação", options: { filter: true, sort: true,
      customBodyRender: (value, tableMeta) => (
        <Box display="flex" alignItems="center">
          <ShowSituation value={value}/>
          {(value === 3 || value === 4 || value === 6) && tableMeta.rowData[11] && (
            <IconButton
              size="small"
              style={{ marginLeft: 8 }}
              onClick={(e) => {
                e.stopPropagation();
                handleJustificationClick(tableMeta.rowData[11]);
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      )}
    },
    {
      name: "predictedValue",
      label: "Valor Previsto",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => FormatRealNumber(value)
      },
    },
    {
      name: "executeValue",
      label: "Valor Executado",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => FormatRealNumber(value)
      },
    },
    { name: "initDate", label: "Data inicial", 
      options: { filter: true, sort: true, customBodyRender: (value) => FormatDate(value,'Não definida')}},
    { name: "deadLine", label: "Data prevista", 
      options: { filter: true, sort: true, customBodyRender: (value) => FormatDate(value,'Não definida')}},
    { name: "justifications", options: { display: false } },
  ], [handleJustificationClick]);

  return (
  <>
   {rowId && <DialogViewTask id={rowId} projectId={id} open={open} close={handleClose} updateData={updateData}/> }
    <CustomTable data={data} columns={columns} opt={options} error={error} load={load} className={className}/>
    <JustificationDialog
      open={justificationOpen}
      onClose={() => setJustificationOpen(false)}
      justifications={selectedJustifications || []}
    />
  </>
    )
  }
  